/**
 * Returns an i18n key (and interpolation options) for a compact relative time
 * label, matching the design: "Just now", "18m ago", "1h ago", "Yesterday",
 * "2 days ago".
 *
 * @param {number} timestamp epoch milliseconds
 * @param {number} [now] epoch milliseconds, injectable for testing
 * @returns {{ key: string, options?: Object }}
 */
export const relativeTimeParts = (timestamp, now = Date.now()) => {
  const diffMs = Math.max(0, now - timestamp)
  const diffMinutes = Math.floor(diffMs / 60000)

  if (diffMinutes < 1) {
    return { key: 'notificationCenter.time.justNow' }
  }
  if (diffMinutes < 60) {
    return { key: 'notificationCenter.time.minutesAgo', options: { count: diffMinutes } }
  }

  const diffHours = Math.floor(diffMinutes / 60)
  if (diffHours < 24) {
    return { key: 'notificationCenter.time.hoursAgo', options: { count: diffHours } }
  }

  // fall back to calendar-day differences so "Yesterday" is accurate regardless
  // of the exact hour boundary.
  const startOfToday = new Date(now)
  startOfToday.setHours(0, 0, 0, 0)
  const startOfThen = new Date(timestamp)
  startOfThen.setHours(0, 0, 0, 0)
  const dayDiff = Math.round((startOfToday.getTime() - startOfThen.getTime()) / 86400000)

  if (dayDiff <= 1) {
    return { key: 'notificationCenter.time.yesterday' }
  }
  return { key: 'notificationCenter.time.daysAgo', options: { count: dayDiff } }
}
